if (!customElements.get('ly-online-chat')) {
    customElements.define('ly-online-chat', class extends HTMLElement {

        connectedCallback() {
            document.addEventListener('DOMContentLoaded', async () => {
                this.container = document.querySelector('#gorgias-chat-container')
                this.addEventListener('click', this.clickHandler)
            })
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.clickHandler)
        }

        clickHandler = async evt => {
            evt.preventDefault()
            if (!this.container) {
                this.container = await waitForElement('#gorgias-chat-container')
            }
            const _iframe = this.container.querySelector('#chat-button')
            _iframe.contentWindow.document.querySelector('#gorgias-chat-messenger-button').click()
        }
    })
}